import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import cave13b from "../assets/cave_13b.png";

const Room13b = ({ goToRoom21, goToRoom20, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={cave13b}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Buttons */}
        <button
          className={sharedStyles.button}
          style={{ top: "40%", left: "25%", position: "absolute" }}
          onClick={goToRoom21}
        >
          Left
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "35%", left: "80%", position: "absolute" }}
          onClick={goToRoom20}
        >
          Right
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room13b;